import * as Sentry from "@sentry/nextjs"
import { Component, type ReactNode } from "react"

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  error: null | Error
}

export class ErrorBoundary extends Component<Props> {
  state: State = {
    error: null,
  }

  static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { error }
  }

  static componentDidCatch(error: Error, info: object) {
    console.error(error, info)
    Sentry.captureException(error, {
      extra: {
        component: "Generic",
      },
    })
  }

  render() {
    if (this.state.error) {
      // Return custom callback or default error
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <div className="text-fg-red">
          {this.state.error.message ?? this.state.error.toString()}
        </div>
      )
    }

    return this.props.children
  }
}
